export const MAINTENANCE_MODE = 503
export const UNAUTHORIZED = 401
